export class ContextNotProvidedError extends Error {
  constructor(contextName = "Context") {
    super(`No ${contextName} provided`);
    this.name = ContextNotProvidedError.name;
  }
}
